<template>
  <div
    :class="[isLoaded ? 'opacity-1' : 'opacity-0']"
    class="m-0-16 mb-16 mt-6 scroll-y h-full relative"
    ref="scroller"
    @scroll="handlerLoadingDetailMore"
  >
    <common-empty v-if="!recordList.length" content="暂无数据"></common-empty>
    <RecycleScroller
      v-else
      element-loading-text="加载中"
      class="scroller"
      :items="recordList"
      :item-size="6"
      key-field="id"
    >
      <template v-slot="{ item }">
        <div class="w-full h-158 bd-radio-8 bg-FFFFFF mt-6 p-0-16 p-16-0">
          <div class="fb fb-cross-center fb-main-start" v-show="!isMember"
            ><span class="font-34 font-bold pr-6">{{
              filterName(item.studentName, 4)
            }}</span
            ><span class="font-28 c-171A1D-60">{{
              filterName(item.className, 8)
            }}</span></div
          >
          <div class="fb fb-cross-center fb-main-between">
            <div class="lh-24 font-28 c-171A1D-60">
              <p
                :class="[
                  isMember ? 'font-34 font-bold pr-6 c-000 mb-8' : 'mt-8'
                ]"
                >{{ isMember ? '' : '行为：' }}{{ item.behavior }}</p
              >
              <p>节次：{{ item.section }}</p>
              <p>时间：{{ timeFormat(new Date(+item.time), 'MM.DD hh:mm') }}</p>
              <p>座位：{{ item.seatingName }}</p>
            </div>
            <div
              class="w-160 h-90 bd-radio-4 hidden item-shrink-0"
              @click="viewBig(item)"
            >
              <img
                width="100%"
                height="100%"
                v-if="item.thumbnailUrl"
                :src="item.thumbnailUrl"
              />
            </div>
          </div>
        </div>
      </template>
    </RecycleScroller>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonEmpty from './commonEmpty'
import { RecycleScroller } from 'vue-virtual-scroller'
import API from '@/api'
import { mcToast } from '@/utils/mcSdkUtils'
import { filterName, timeFormat } from '@/utils/comUtils'
export default {
  mixins: [mixin],
  props: {
    dateOps: {
      type: Object,
      default: () => {}
    },
    studentDingId: {
      type: String,
      default: ''
    },
    isMember: {
      type: Boolean,
      default: false
    }
  },
  components: { RecycleScroller, commonEmpty },
  data() {
    return {
      timeFormat,
      filterName,
      recordList: [],
      pageNumber: 0,
      pageSize: 20,
      pageTotal: 0,
      isLoadDetailMore: true,
      isLoading: false,
      isLoaded: false
    }
  },
  watch: {
    dateOps: {
      handler() {
        const { dimDay, startDimDay, endDimDay } = this.dateOps || {}
        if (dimDay || startDimDay || endDimDay) {
          window.scrollTo(0, 1)
          this.recordList = []
          this.pageNumber = 0
          this.isLoadDetailMore = true
          this.isLoading = false
          this.fetchData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {},
  methods: {
    // 加载更多
    handlerLoadingDetailMore(e) {
      let _el = e.currentTarget
      let isScroll = _el.scrollTop + _el.clientHeight + 20 >= _el.scrollHeight
      this.isLoadDetailMore = this.pageTotal > this.pageNumber
      if (isScroll && this.isLoadDetailMore) {
        this.fetchData(true)
      }
    },
    viewBig(item) {
      if (!item.snapshotUrl) {
        return
      }
      this.$ImagePreview({
        $props: {
          images: [item.snapshotUrl],
          content: '',
          start: 0
        }
      }).show()
    },
    fetchData(isScroller) {
      if (this.isLoading) {
        return
      }
      this.isLoadDetailMore = false
      const { dimDay, startDimDay, endDimDay } = this.dateOps
      const hasDay = dimDay || startDimDay || endDimDay
      this.pageNumber++
      if (hasDay) {
        const showLoading = this.$Toast({
          type: 'loading',
          duration: 600,
          content: '加载中···'
        })
        showLoading.show()
        this.isLoading = true
        API.pageBehavior({
          campusId: this.campusId,
          operUserRoleTypes: `${this.currentRole}`,
          startDimDay: dimDay || startDimDay,
          endDimDay: dimDay || endDimDay,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          studentDingId: this.studentDingId
        })
          .then(res => {
            if (res.result) {
              return mcToast({ msg: res.message })
            }
            this.pageTotal = res.totalPages || 0
            const _res = res.data || []
            this.recordList = isScroller ? this.recordList.concat(_res) : _res
            this.isLoadDetailMore = true
          })
          .catch(err => mcToast({ msg: err.message }))
          .finally(() => {
            this.isLoading = false
            setTimeout(() => {
              this.isLoaded = true
              showLoading.hide()
            }, 600)
          })
      }
    }
  }
}
</script>

<style lang="scss">
.opacity-0 {
  opacity: 0;
}
.opacity-1 {
  opacity: 1;
}
</style>
